import React, { useRef, useState, useEffect, useContext } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import { Box, Button, Checkbox, CircularProgress, Divider, FormControlLabel, Grid, IconButton, TextField, Typography } from "@mui/material";
import { Search, Add, Refresh, Close } from "@mui/icons-material";
import { toUTC } from "../../utils/date.js";
import { useUser } from "../../hook/useUser.js";
import { getElementsDataApi, getMainModelDataApi, getBackgroundModelUrlApi } from "../../api/model";
import { getCommentsApi, getCommentsDetailsApi, resolveCommentsApi } from "../../api/comment";
import { getCommentStatusApi, getCommentTypeApi, getDamagingEnergyApi } from "../../api/predefine.js";
import { getContractorsApi } from "../../api/member.js";
import { getElementStatus } from "../../utils/schedule.js";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { NotificationContext } from "../../component/popup/NotificationProvider";
import dayjs from "dayjs";
import Container from "../../component/Container.js";
import DatePicker from "../../component/DatePicker.js";
import IFCViewer from "../../component/bim/IFCViewer.js";
import SelectComponent from "../../component/SelectComponent.js";
import MainTable from "../../component/table/MainTable.js";
import CommentsList from "../3DModelPage/components/CommentsList.js";
import AddCommentPopup from "../3DModelPage/components/AddCommentPopup.js";
import CommentsDetailsPopup from "../3DModelPage/components/CommentsDetailsPopup.js";
import FiltersPopup from "../../component/popup/FiltersPopup.js";

const ObservationPage = () => {
  const { projectId } = useParams();
  const { showSuccess, showError } = useContext(NotificationContext);
  const { user } = useUser(projectId);
  const container = useRef();
  const [elementIds, setElementIds] = useState({
    planProgress: [],
    actualProgress: [],
    delayed: [],
    planComplete: [],
    actualComplete: [],
    actualHide: [],
    hideElementIds: [],
    showFilter: [],
    white: [],
    all: [],
  });
  const [state, setState] = useState({
    contractorOptions: [],
    contractorElementValue: [],
    workSetOptions: [],
    viewOptions: [
      { value: "Full view", label: "Full view" },
      { value: "Actual view", label: "Actual view" },
      { value: "Plan view", label: "Plan view" },
    ],
    backgroundOptions: [],
    worksetValue: [],
    viewValue: "",
    backgroundValue: [],
    backgroundModels: [],
    commentsFilterValue: "Off",
    commentsFilterOptions: [
      { value: "Off", label: "Off" },
      { value: "Site Matter", label: "Site Matter" },
      { value: "Safety", label: "Safety" },
      { value: "Design", label: "Design" },
    ],
    expandedTasks: [],
    taskTableData: [],
    filteredTaskData: [],
    startDate: dayjs(),
    endDate: dayjs(),
    currentDate: dayjs(),
    radioValue: "Month",
    showPopup: false,
    modelURL: [],
    elementsData: [],
    page: 0,
    rowsPerPage: 20,
  });
  const [commentFilterState, setCommentFilterState] = useState({
    categoryOptions: [],
    categoryValues: [],
    statusOptions: [],
    statusValues: [],
    damagingEnergyOptions: [],
    damagingEnergyValues: [],
    positiveSafetyObservation: false,
    startDate: null,
    endDate: null,
    assignToMe: false,
    myComments: false,
    search: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingCommentDetail, setIsLoadingCommentDetail] = useState(false);
  const [comments, setComments] = useState([]);
  const commentsRef = useRef(comments); // for ifc viewer onclick event to reference latest comments state
  const [filteredComments, setFilteredComments] = useState([]);
  const [commentTableData, setCommentTableData] = useState([]);
  const [addCommentsPopup, setAddCommentsPopup] = useState(false);
  const [selectedCommentId, setSelectedCommentId] = useState([]);
  const [selectedComment, setSelectedComment] = useState([]);

  const [selectedElement, setSelectedElement] = useState();
  const selectedElementRef = useRef(selectedElement); // for ifc viewer onclick event to reference latest selectedElement state
  const [commonProps, setCommonProps] = useState({});

  const [isResolving, setIsResolving] = useState(false);

  const [showSearch, setShowSearch] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const showFiltersRef = useRef(false); // for headerRightButtonRef onclick event to reference latest showFilters state

  const { headerRightButtonRef } = useOutletContext();

  headerRightButtonRef.current = {
    icon: "assets/icons/tune.svg",
    onClick: () => {
      showFiltersRef.current = !showFiltersRef.current;
      setShowFilters(showFiltersRef.current);
    },
  };
  const selectComponents = [
    {
      Component: SelectComponent,
      options: state.workSetOptions,
      value: state.worksetValue,
      isMultiSelect: true,
      onChange: (value) => {
        setState((prevState) => ({
          ...prevState,
          worksetValue: value,
          modelURL: state.modelURL.map((mainModel) => {
            return {
              ...mainModel,
              visible: value.includes(mainModel.workset),
            };
          }),
        }));
      },
      selectLabel: "Workset",
      placeholder: "select an item...",
    },
    {
      Component: SelectComponent,
      options: state.viewOptions,
      value: state.viewValue,
      onChange: (value) => {
        setState((prevState) => ({
          ...prevState,
          viewValue: value,
        }));
      },
      selectLabel: "View",
    },
    {
      Component: SelectComponent,
      options: state.contractorOptions,
      value: state.contractorElementValue,
      isMultiSelect: true,
      onChange: (value) => {
        setState((prevState) => ({
          ...prevState,
          contractorElementValue: value,
        }));
      },
      selectLabel: "Contractor",
      placeholder: "select an item...",
    },
    {
      Component: SelectComponent,
      options: state.backgroundOptions,
      value: state.backgroundValue,
      isMultiSelect: true,
      required: false,
      onChange: (value) => {
        setState((prevState) => ({
          ...prevState,
          backgroundValue: value,
          backgroundModels: state.backgroundModels.map((backgroundModel) => {
            return {
              ...backgroundModel,
              visible: value.includes(backgroundModel.fileURL),
            };
          }),
        }));
      },
      selectLabel: "Background",
      placeholder: "Select an item...",
    },
  ];
  const filterComponents = [
    {
      Component: SelectComponent,
      options: commentFilterState.categoryOptions,
      value: commentFilterState.categoryValues,
      isMultiSelect: true,
      onChange: (value) => {
        setCommentFilterState((prevState) => ({
          ...prevState,
          categoryValues: value,
        }));
      },
      selectLabel: "Category",
      placeholder: "select an item...",
    },
    {
      Component: SelectComponent,
      options: commentFilterState.statusOptions,
      value: commentFilterState.statusValues,
      isMultiSelect: true,
      onChange: (value) => {
        setCommentFilterState((prevState) => ({
          ...prevState,
          statusValues: value,
        }));
      },
      selectLabel: "Status",
      placeholder: "select an item...",
    },
  ];

  const commentTableHeaders = [
    { id: "projectCommentId", label: "Comment ID", align: "center" },
    { id: "header", label: "Comment Header Input", align: "left" },
    {
      id: "createDateTime",
      label: "Created Date",
      align: "center",
      type: "date",
    },
    { id: "category", label: "Category", align: "left" },
    { id: "damagingEnergy", label: "Damaging Energy", align: "left" },
    { id: "positiveSafetyObservation", label: "PSO", align: "center" },
    { id: "createBy", label: "Created by", align: "left" },
    { id: "issueTo", label: "Action by", align: "left" },
    { id: "status", label: "Status", align: "center", defaultSortOrder: "asc" },
  ];

  const commentTableMobileHeaders = [
    { id: "status", label: "", align: "center", defaultSortOrder: "asc" },
    { id: "projectCommentId", label: "Comment ID", align: "center" },
    { id: "header", label: "Comment Header Input", align: "left" },
    {
      id: "createDateTime",
      label: "Created Date",
      align: "center",
      type: "date",
    },
    { id: "createBy", label: "Created by", align: "left" },
  ];

  const readonly = !user?.editRight;

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([
        getContractorsData(),
        getMainModel(),
        getBackgroundModelUrl(),
        getCommentsData(),
        getCommentTypeData(),
        getCommentStatusData(),
        getDamagingEnergyData(),
      ]);
      setState((prevState) => ({
        ...prevState,
        viewValue: "Actual view",
      }));
      setIsLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (state.viewValue === "Actual view") {
      setCommonProps(() => ({
        showFilterElementIds: elementIds.showFilter,
        allElementIds: elementIds.all,
        highlightElementIds: [],
        hideElementIds: [...elementIds.actualHide, ...elementIds.hideElementIds],
        delayedNotStartElementIds: elementIds.delayedNotStart,
        inProgressElementIds: elementIds.actualProgress,
        delayedElementIds: elementIds.delayed,
      }));
    } else if (state.viewValue === "Plan view") {
      setCommonProps(() => ({
        showFilterElementIds: elementIds.showFilter,
        allElementIds: elementIds.all,
        highlightElementIds: [],
        hideElementIds: [...elementIds.planHide, ...elementIds.hideElementIds],
        inProgressElementIds: elementIds.planProgress,
      }));
    } else {
      setCommonProps(() => ({
        showFilterElementIds: elementIds.showFilter,
        allElementIds: elementIds.all,
        highlightElementIds: [],
        hideElementIds: elementIds.hideElementIds,
        delayedNotStartElementIds: [],
        inProgressElementIds: [],
        delayedElementIds: [],
      }));
    }
  }, [state.viewValue, elementIds]);

  useEffect(() => {
    getCommentDetailedData();
  }, [selectedCommentId]);

  useEffect(() => {
    selectedElementRef.current = selectedElement;
  }, [selectedElement]);

  useEffect(() => {
    commentsRef.current = comments;
  }, [comments]);

  useEffect(() => {
    if (isMobile) {
      handleSearchClick();
    }
  }, [commentFilterState.categoryValues, commentFilterState.statusValues]);

  useEffect(() => {
    if (state.worksetValue.length > 0 && state.elementsData.length > 0) {
      colorRulesData(state.elementsData);
    }
  }, [state.worksetValue, state.elementsData, state.currentDate, state.contractorElementValue]);

  const handleElementClick = async (point, bimElementId, elementCenter) => {
    setSelectedComment([]);
    // no element is clicked, reset
    if (!bimElementId) {
      setSelectedElement();
      container.current.selectionHighlight.clear();
      setFilteredComments([...commentsRef.current]);
      setCommentTableData(
        commentsRef.current.map((c) => {
          return {
            id: c.commentId,
            header: c.header,
            commentId: c.commentId,
            projectCommentId: c.projectCommentId,
            createDateTime: c.createDateTime,
            category: c.commentType,
            damagingEnergy: c.damagingEnergyValues?.length ? c.damagingEnergyValues.join(", ") : "-",
            positiveSafetyObservation: c.commentType === "Safety Issue" ? (c.positiveSafetyObservation ? "Y" : "N") : "-",
            createBy: c.createBy.name,
            issueTo: c.issueTo.name,
            status: c.status,
          };
        })
      );
      return;
    }
    // same element is clicked, reset
    if (bimElementId === selectedElementRef.current?.bimElementId) {
      setSelectedElement();
      container.current.selectionHighlight.clear();
      setFilteredComments([...commentsRef.current]);
      setCommentTableData(
        commentsRef.current.map((c) => {
          return {
            id: c.commentId,
            header: c.header,
            commentId: c.commentId,
            projectCommentId: c.projectCommentId,
            createDateTime: c.createDateTime,
            category: c.commentType,
            damagingEnergy: c.damagingEnergyValues?.length ? c.damagingEnergyValues.join(", ") : "-",
            positiveSafetyObservation: c.commentType === "Safety Issue" ? (c.positiveSafetyObservation ? "Y" : "N") : "-",
            createBy: c.createBy.name,
            issueTo: c.issueTo.name,
            status: c.status,
          };
        })
      );
      return;
    }
    setSelectedElement({ point, bimElementId, elementCenter });
    setFilteredComments(commentsRef.current.filter((c) => c.elementId === bimElementId));
    setCommentTableData(
      commentsRef.current
        .filter((c) => c.elementId === bimElementId)
        .map((c) => {
          return {
            id: c.commentId,
            header: c.header,
            commentId: c.commentId,
            projectCommentId: c.projectCommentId,
            createDateTime: c.createDateTime,
            category: c.commentType,
            damagingEnergy: c.damagingEnergyValues?.length ? c.damagingEnergyValues.join(", ") : "-",
            positiveSafetyObservation: c.commentType === "Safety Issue" ? (c.positiveSafetyObservation ? "Y" : "N") : "-",
            createBy: c.createBy.name,
            issueTo: c.issueTo.name,
            status: c.status,
          };
        })
    );
  };

  const handleSearchClick = async (searchString) => {
    setState((prevState) => ({ ...prevState, page: 0 }));
    setIsLoading(true);
    await getCommentsData(searchString);
    setIsLoading(false);
  };

  const handleResetClick = async () => {
    setState((prevState) => ({ ...prevState, page: 0 }));
    setIsLoading(true);
    setSelectedElement();
    container.current?.selectionHighlight.clear();
    setCommentFilterState((prevState) => ({
      ...prevState,
      categoryValues: prevState.categoryOptions.map((d) => d.value),
      statusValues: prevState.statusOptions.map((d) => d.value),
      damagingEnergyValues: prevState.damagingEnergyOptions.map((d) => d.value),
      positiveSafetyObservation: false,
      startDate: null,
      endDate: null,
      assignToMe: false,
      myComments: false,
      search: "",
    }));
    await getCommentsData({
      categoryValues: commentFilterState.categoryOptions.map((d) => d.value),
      statusValues: commentFilterState.statusOptions.map((d) => d.value),
      // damagingEnergyValues: commentFilterState.damagingEnergyOptions.map((d) => d.value),
      // positiveSafetyObservation: false,
      damagingEnergyValues: null,
      positiveSafetyObservation: undefined,
      startDate: null,
      endDate: null,
      assignToMe: false,
      myComments: false,
      selectedElement: undefined,
    });

    setIsLoading(false);
  };

  const colorRulesData = (data) => {
    const elementStatus = getElementStatus(data, state.currentDate);
    let allIds = data?.map((item) => item?.bimElementId);
    setElementIds((prevState) => ({
      ...prevState,
      ...elementStatus,
      all: allIds,
      // filter contractor
      hideElementIds:
        state.contractorElementValue.length === 0 || state.contractorElementValue.length === state.contractorOptions.length
          ? []
          : data.filter((item) => !state.contractorElementValue.includes(item.contractor)).map((item) => item?.bimElementId),
    }));
  };

  //get main model url and workset
  const getMainModel = async () => {
    const result = await getMainModelDataApi(projectId);
    const data = result?.data;

    if (data && Array.isArray(data)) {
      const mainModels = data.map((d) => {
        return {
          ...d,
          fileURL: d.fileURL,
          visible: true,
        };
      });

      setState((prevState) => ({
        ...prevState,
        modelURL: mainModels,
      }));

      const uniqueWorksets = new Set(data.map((item) => item.workset));
      const workSetOptionsArray = Array.from(uniqueWorksets).map((workset) => ({
        value: workset,
        label: workset,
      }));
      setState((prevState) => ({
        ...prevState,
        workSetOptions: workSetOptionsArray,
      }));

      if (uniqueWorksets.size > 0) {
        setState((prevState) => ({
          ...prevState,
          worksetValue: Array.from(uniqueWorksets),
        }));
      }
      await getElementsData();
    }
  };
  //get background model url&filter
  const getBackgroundModelUrl = async () => {
    const result = await getBackgroundModelUrlApi(projectId);
    const data = result?.data;
    if (data && Array.isArray(data)) {
      const backgroundModels = data.map((d) => {
        return {
          ...d,
          fileURL: d.fileURL,
          visible: false,
        };
      });
      const backgroundArray = backgroundModels.map((item) => ({
        value: item.fileURL,
        label: item.filename,
      }));
      setState((prevState) => ({
        ...prevState,
        backgroundOptions: backgroundArray,
        backgroundModels: backgroundModels,
        // backgroundValue: backgroundArray.map((b) => b.value),
        backgroundValue: [],
      }));
    }
  };

  const getElementsData = async () => {
    try {
      const result = await getElementsDataApi(projectId);
      const data = result?.data;
      if (!data) showError("No element data returned from API.");

      setState((prevState) => {
        const newState = {
          ...prevState,
          elementsData: data,
        };
        colorRulesData(newState.elementsData);
        return newState;
      });
    } catch {
      showError("Received element data occurred error.");
    }
  };

  //get all comments
  const getCommentsData = async (latestCommentFilterState) => {
    const commentFilters = latestCommentFilterState || commentFilterState;
    const result = await getCommentsApi(
      projectId,
      undefined,
      commentFilters.search,
      commentFilters.categoryValues?.length ? commentFilters.categoryValues.join(",") : undefined,
      commentFilters.statusValues?.length ? commentFilters.statusValues.join(",") : undefined,
      commentFilters.damagingEnergyValues?.length && showSafetyCheckBoxes() ? commentFilters.damagingEnergyValues.join(",") : undefined,
      // commentFilters.positiveSafetyObservation && showSafetyCheckBoxes()
      //   ? 1
      //   : !commentFilters.positiveSafetyObservation && showSafetyCheckBoxes()
      //     ? 0
      //     : undefined,
      commentFilters.positiveSafetyObservation === undefined
        ? undefined
        : showSafetyCheckBoxes()
        ? commentFilters.positiveSafetyObservation
          ? 1
          : 0
        : undefined,
      commentFilters.startDate ? toUTC(`${commentFilters.startDate.format("YYYY/MM/DD")} 00:00:00`).format("YYYY/MM/DD HH:mm:ss") : undefined,
      commentFilters.endDate ? toUTC(`${commentFilters.endDate.format("YYYY/MM/DD")} 23:59:59`).format("YYYY/MM/DD HH:mm:ss") : undefined,
      commentFilters.assignToMe ? 1 : undefined
    );
    if (result?.data) {
      setComments(result.data);
      const targetElement = Object.keys(commentFilters).includes("selectedElement") ? commentFilters.selectedElement : selectedElement;
      const filteredComments = targetElement ? result.data.filter((c) => c.elementId === targetElement.bimElementId) : result.data;
      setFilteredComments(filteredComments);
      setCommentTableData(
        filteredComments.map((c) => {
          return {
            id: c.commentId,
            header: c.header,
            commentId: c.commentId,
            projectCommentId: c.projectCommentId,
            createDateTime: c.createDateTime,
            category: c.commentType,
            damagingEnergy: c.damagingEnergyValues?.length ? c.damagingEnergyValues.join(", ") : "-",
            positiveSafetyObservation: c.commentType === "Safety Issue" ? (c.positiveSafetyObservation ? "Y" : "N") : "-",
            createBy: c.createBy.name,
            issueTo: c.issueTo.name,
            status: c.status,
          };
        })
      );
    }
  };

  //get comment type data
  const getCommentTypeData = async () => {
    try {
      const result = await getCommentTypeApi();
      setCommentFilterState((prevState) => ({
        ...prevState,
        categoryOptions: result?.data,
        categoryValues: result?.data.map((d) => d.value),
      }));
    } catch {
      showError("Received comment type data occurred error.");
    }
  };

  //get comment status data
  const getCommentStatusData = async () => {
    try {
      const result = await getCommentStatusApi();
      setCommentFilterState((prevState) => ({
        ...prevState,
        statusOptions: result?.data,
        statusValues: result?.data.map((d) => d.value),
      }));
    } catch {
      showError("Received comment statu data occurred error.");
    }
  };
  //get DamagingEnergy data
  const getDamagingEnergyData = async () => {
    try {
      const result = await getDamagingEnergyApi();
      setCommentFilterState((prevState) => ({
        ...prevState,
        damagingEnergyOptions: result?.data,
        damagingEnergyValues: result?.data.map((d) => d.value),
      }));
    } catch {
      showError("Received damaging energy data occurred error.");
    }
  };

  const getCommentDetailedData = async () => {
    if (selectedCommentId.length) {
      setIsLoadingCommentDetail(true);
      const result = await getCommentsDetailsApi(projectId, undefined, selectedCommentId[0]);
      setSelectedComment(result.data);
      if (result.data.length) {
        if (result.data[0].elementId) {
          setSelectedElement({
            point: result.data[0].location,
            bimElementId: result.data[0].elementId,
            elementCenter: result.data[0].location,
          });
        }
      }
      setIsLoadingCommentDetail(false);
    } else {
      setSelectedComment([]);
    }
  };

  const getContractorsData = async () => {
    try {
      const result = await getContractorsApi(projectId);
      const data = result?.data;
      if (data) {
        const conTractors = new Set(data?.map((item) => item.name));
        const options = Array.from(conTractors).map((item) => ({
          label: item,
          value: item,
        }));
        setState((prevState) => ({
          ...prevState,
          contractorOptions: options,
        }));
        if (Array.from(conTractors).length > 0) {
          setState((prevState) => ({
            ...prevState,
            contractorElementValue: Array.from(conTractors),
          }));
        }
      }
    } catch {
      showError("Received contractor data occurred error.");
    }
  };

  const handleResolveComment = async (commentId) => {
    setIsResolving(true);
    try {
      //resolve comment
      await resolveCommentsApi(projectId, commentId);
      //reload comments when resolve
      const result = await getCommentsDetailsApi(projectId, undefined, selectedCommentId[0]);
      getCommentsData();
      setSelectedComment(result.data);
      showSuccess("The comment has been successfully resolved.");
    } catch {
      showError("Resolve failed.");
    } finally {
      setIsResolving(false);
    }
  };

  const handleCommentAdded = async () => {
    getCommentDetailedData();
    getCommentsData();
    setAddCommentsPopup(false);
  };

  const handleCheckBox = (event) => {
    const value = parseInt(event.target.value, 10);
    let newStatus;

    if (event.target.checked) {
      newStatus = [...commentFilterState.damagingEnergyValues, value];
    } else {
      newStatus = commentFilterState.damagingEnergyValues.filter((item) => item !== value);
    }

    setCommentFilterState((prevState) => ({
      ...prevState,
      damagingEnergyValues: newStatus,
    }));
  };

  const showSafetyCheckBoxes = () => {
    return commentFilterState.categoryValues.length !== commentFilterState.categoryOptions.length && commentFilterState.categoryValues.includes(3);
  };

  return (
    <>
      <Box width="100%" height="100%" display="flex" gap={2}>
        <BrowserView>
          <Box width={800} height="100%" display="flex" flexDirection="column" gap={2}>
            <Box height={500} width={"100%"}>
              <IFCViewer
                ref={container}
                modelURL={state.modelURL}
                backgroundModels={state.backgroundModels}
                comments={comments.filter((c) => c.location.x && c.status === "Pending")}
                title={"3D Model View"}
                onClick={handleElementClick}
                selectComponents={selectComponents}
                selectionHighlightElementIds={selectedElement ? [selectedElement.bimElementId] : []}
                advanced
                {...commonProps}
              ></IFCViewer>
            </Box>
            <Container
              title="Comment"
              icon="/assets/icons/comment2.svg"
              sx={{
                flex: 1,
                background: selectedComment.length || isLoadingCommentDetail ? "white" : "#00000080",
              }}
            >
              {isLoadingCommentDetail ? (
                <Box
                  width="100%"
                  height="calc(100% - 25px)"
                  display="flex"
                  flexDirection="column"
                  gap={1}
                  justifyContent="center"
                  alignItems="center"
                >
                  <CircularProgress />
                </Box>
              ) : selectedComment.length > 0 ? (
                <Box width="100%" px={2} pt={2}>
                  {selectedComment.map((comment, index) => (
                    <Box key={comment.commentId}>
                      {index > 0 && <Divider sx={{ my: 1 }} />}
                      <CommentsList comment={comment} onCommentResolved={handleResolveComment} horizontal user={user} />
                    </Box>
                  ))}
                </Box>
              ) : (
                <Box
                  width="100%"
                  height="calc(100% - 25px)"
                  display="flex"
                  flexDirection="column"
                  gap={1}
                  justifyContent="center"
                  alignItems="center"
                >
                  <img src="/assets/icons/comment2.svg" alt="comment" style={{ width: 64, height: 64 }}></img>
                  {/* <Typography variant="h4" sx={{ color: "white", fontWeight: "bold" }}>
                  {selectedElement ? "No comments" : "Select a model element or"}
                </Typography>
                <Typography variant="h4" sx={{ color: "white", fontWeight: "bold" }}>
                  {selectedElement ? "" : "item to view comments"}
                </Typography> */}
                  <Typography variant="h4" sx={{ color: "white", fontWeight: "bold" }}>
                    Select an item to view comment
                  </Typography>
                </Box>
              )}
            </Container>
          </Box>
        </BrowserView>
        <Box display="flex" flexDirection="column" gap={isMobile ? 0 : 2} justifyContent="space-between" height="100%">
          <BrowserView>
            <Button
              onClick={() => setAddCommentsPopup(true)}
              variant="contained"
              color={readonly ? "primary" : "secondary"}
              sx={{
                pr: 1.5,
                pl: 1,
                py: 0,
                lineHeight: "35px",
                borderRadius: "20px",
                width: 140,
                mb: 2,
              }}
              startIcon={<img src={`assets/buttons/addcomment${readonly ? "-disabled" : ""}.svg`} alt="Add Comment" />}
              disabled={readonly}
            >
              Add Comment
            </Button>
            <Grid
              container
              rowSpacing={1}
              sx={{
                backgroundColor: "#F1F1F1",
                borderRadius: "10px",
                px: 2,
                pb: 1,
                m: 0,
                width: "100%",
              }}
            >
              <Grid item xs={2.5}>
                <SelectComponent
                  options={commentFilterState.categoryOptions}
                  value={commentFilterState.categoryValues}
                  isMultiSelect
                  onChange={(value) => {
                    setCommentFilterState((prevState) => ({
                      ...prevState,
                      categoryValues: value,
                    }));
                  }}
                  selectLabel={"Category"}
                  placeholder={"Select an item..."}
                />
              </Grid>
              <Grid item xs={2.5}>
                <SelectComponent
                  options={commentFilterState.statusOptions}
                  value={commentFilterState.statusValues}
                  isMultiSelect
                  onChange={(value) => {
                    setCommentFilterState((prevState) => ({
                      ...prevState,
                      statusValues: value,
                    }));
                  }}
                  selectLabel={"Status"}
                  placeholder={"Select an item..."}
                />
              </Grid>
              <Grid item xs={5}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#333",
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                  }}
                >
                  Date Range
                </Typography>
                <Box display="flex" gap={0.5} alignItems="center" sx={{ my: 0.5 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={commentFilterState.startDate}
                      onChange={(date) =>
                        setCommentFilterState((prevState) => ({
                          ...prevState,
                          startDate: date,
                        }))
                      }
                      inputStyle={{ height: 26, py: 0 }}
                      sx={{ backgroundColor: "white" }}
                    />
                    <Typography>to</Typography>
                    <DatePicker
                      value={commentFilterState.endDate}
                      onChange={(date) =>
                        setCommentFilterState((prevState) => ({
                          ...prevState,
                          endDate: date,
                        }))
                      }
                      inputStyle={{ height: 26, py: 0 }}
                      sx={{ backgroundColor: "white" }}
                    />
                  </LocalizationProvider>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Box display="flex" flexDirection="column" height="100%" justifyContent="flex-end" sx={{ ml: 2, pb: "5px" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={commentFilterState.assignToMe}
                        onChange={(e) => {
                          setCommentFilterState((prevState) => ({
                            ...prevState,
                            assignToMe: e.target.checked,
                          }));
                        }}
                        name={"Assign to me"}
                        color="primary"
                        sx={{ px: 0.5, py: 0.3 }}
                      />
                    }
                    label={"Assign to me"}
                    sx={{ minWidth: "110px", mr: 0.5, ml: "-6px" }}
                  />
                  {/* <FormControlLabel
                  control={
                    <Checkbox
                      checked={commentFilterState.myComments}
                      onChange={(e) => setCommentFilterState((prevState) => ({ ...prevState, myComments: e.target.checked }))}
                      name={"My Comments"}
                      color="primary"
                      sx={{ px: 0.5, py: 0.3 }}
                    />
                  }
                  label={"My Comments"}
                  sx={{ minWidth: "110px", mr: 0.5, ml: "-6px" }}
                /> */}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" gap={1} alignItems="center">
                  <Typography sx={{ minWidth: 100 }}>Search Keywords:</Typography>
                  <TextField
                    value={commentFilterState.search}
                    onChange={(e) =>
                      setCommentFilterState((prevState) => ({
                        ...prevState,
                        search: e.target.value,
                      }))
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearchClick();
                      }
                    }}
                    placeholder="Enter keyword..."
                    variant="outlined"
                    fullWidth
                    sx={{
                      my: 0.5,
                      "& .MuiInputBase-input": {
                        pt: 0.5,
                        pb: "6px",
                      },
                      "& .MuiInputBase-root": {
                        background: "#fff",
                      },
                    }}
                  />
                  <Button
                    onClick={() => handleSearchClick()}
                    variant="contained"
                    color="secondary"
                    sx={{
                      py: 0.3,
                      borderRadius: "10px",
                    }}
                  >
                    Search
                  </Button>
                  <Button
                    onClick={handleResetClick}
                    variant="outlined"
                    color="inherit"
                    sx={{
                      py: 0.2,
                      borderRadius: "10px",
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Grid>
              {showSafetyCheckBoxes() && (
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: "#333",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <span style={{ fontWeight: 700 }}>Damaging Energy </span>
                    (Select one or more when applicable)
                  </Typography>
                  <Box>
                    {commentFilterState.damagingEnergyOptions?.map((item) => {
                      const isChecked = (commentFilterState.damagingEnergyValues || []).includes(item.value);
                      return (
                        <FormControlLabel
                          key={item.value}
                          control={
                            <Checkbox
                              checked={isChecked}
                              onChange={handleCheckBox}
                              value={item.value}
                              name={item.label}
                              color="primary"
                              sx={{ px: 0.5, py: 0.3 }}
                            />
                          }
                          label={item.label}
                          sx={{ minWidth: "110px", mr: 0.5, ml: "-6px" }}
                        />
                      );
                    })}
                  </Box>
                </Grid>
              )}
              {showSafetyCheckBoxes() && (
                <Grid item xs={12}>
                  <Box display="flex" gap={1}>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        color: "#333",
                        whiteSpace: "nowrap",
                        fontWeight: 700,
                      }}
                    >
                      Positive Safety Observation (PSO)
                    </Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={commentFilterState.positiveSafetyObservation}
                          onChange={(e) => {
                            setCommentFilterState((prevState) => ({
                              ...prevState,
                              positiveSafetyObservation: e.target.checked,
                            }));
                          }}
                          value={commentFilterState.positiveSafetyObservation}
                          name={" Positive Safety Observation (PSO)"}
                          color="primary"
                          sx={{ px: 0.5, py: 0.3 }}
                        />
                      }
                      label={""}
                      sx={{ minWidth: "110px", mr: 0.5, ml: "-6px" }}
                    />
                  </Box>
                </Grid>
              )}
            </Grid>
          </BrowserView>
          {showSearch && (
            <Box>
              <Typography sx={{ color: "#333", fontWeight: 700, whiteSpace: "nowrap" }}>Search - Keywords</Typography>
              <TextField
                value={commentFilterState.search}
                onChange={(e) =>
                  setCommentFilterState((prevState) => ({
                    ...prevState,
                    search: e.target.value,
                  }))
                }
                placeholder="Enter keyword..."
                variant="outlined"
                fullWidth
                sx={{
                  my: 0.5,
                  "& .MuiInputBase-input": {
                    pt: 0.5,
                    pb: "6px",
                  },
                  "& .MuiInputBase-root": {
                    background: "#fff",
                  },
                }}
              />
              <Typography sx={{ color: "#333", fontWeight: 700, whiteSpace: "nowrap" }}>Search - Date Range</Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  my: 0.5,
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={commentFilterState.startDate}
                    onChange={(date) =>
                      setCommentFilterState((prevState) => ({
                        ...prevState,
                        startDate: date,
                      }))
                    }
                    inputStyle={{ height: 26, py: 0 }}
                  />
                  <Typography>to</Typography>
                  <DatePicker
                    value={commentFilterState.endDate}
                    onChange={(date) =>
                      setCommentFilterState((prevState) => ({
                        ...prevState,
                        endDate: date,
                      }))
                    }
                    inputStyle={{ height: 26, py: 0 }}
                  />
                </LocalizationProvider>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  my: 0.5,
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<Search />}
                  sx={{ flex: 1, borderRadius: "4px", height: 25 }}
                  onClick={() => handleSearchClick()}
                >
                  Search
                </Button>
                <IconButton
                  onClick={() => handleResetClick()}
                  aria-label="reset"
                  sx={{
                    border: "1px solid #c6ccd2",
                    borderRadius: "4px",
                    padding: "2px 3px",
                    boxSizing: "border-box",
                  }}
                >
                  <Refresh sx={{ fontSize: "20px" }} />
                </IconButton>
                <IconButton
                  onClick={() => {
                    setShowSearch(false);
                  }}
                  aria-label="reset"
                  sx={{
                    border: "1px solid #c6ccd2",
                    borderRadius: "4px",
                    padding: "2px 3px",
                    boxSizing: "border-box",
                  }}
                >
                  <Close sx={{ fontSize: "20px" }} />
                </IconButton>
              </Box>
            </Box>
          )}
          <MainTable
            paperSx={{
              flex: 1,
              maxWidth: "95dvw",
            }}
            sx={{
              maxHeight: isMobile ? (showSearch ? "100%" : "calc(100% - 50px)") : "calc(100% - 52px)",
              height: isMobile ? (showSearch ? "100%" : "calc(100% - 50px)") : "calc(100% - 52px)",
              boxShadow: "none",
              ".MuiButtonBase-root.MuiTableSortLabel-root.Mui-active": {
                color: "#000",
              },
              ".MuiButtonBase-root.MuiTableSortLabel-root:hover": {
                color: "#000",
              },
              ".MuiTableSortLabel-icon": {
                color: "#000!important",
                opacity: "1!important",
              },
            }}
            columns={isMobile ? commentTableMobileHeaders : commentTableHeaders}
            rows={commentTableData}
            headerStyles={{
              default: { backgroundColor: "#F1F1F1" },
            }}
            columnWidths={{
              category: "90px",
            }}
            selectable="single"
            rowClickColor={"#EBFFFE"}
            selected={selectedCommentId}
            setSelected={(id) => {
              if (selectedCommentId[0] === id[0]) {
                setSelectedCommentId([]);
                setSelectedComment([]);
              } else {
                setSelectedCommentId(id);
              }
              setSelectedElement();
            }}
            sortable
            sortableColumns={["status", "createDateTime"]}
            iconColumnName={isMobile ? "status" : null}
            iconImage={(status) => {
              if (status === "Pending") {
                return "assets/icons/orangeclock.svg";
              } else return "assets/icons/ok.svg";
            }}
            disableIconButtonClick
            showPagination={isMobile ? false : true}
            page={state.page}
            rowsPerPage={state.rowsPerPage}
            onPageChange={(newPage) => setState((prevState) => ({ ...prevState, page: newPage }))}
            onRowsPerPageChange={(newRowsPerPage) =>
              setState((prevState) => ({
                ...prevState,
                rowsPerPage: newRowsPerPage,
              }))
            }
            isLoading={isLoading}
          />
        </Box>
      </Box>
      <AddCommentPopup
        open={addCommentsPopup}
        onClose={() => {
          setAddCommentsPopup(false);
        }}
        selectedElement={selectedElement}
        onCommentAdded={handleCommentAdded}
      ></AddCommentPopup>
      <CommentsDetailsPopup
        open={selectedCommentId.length && isMobile}
        onClose={() => {
          setSelectedCommentId([]);
        }}
        onCommentResolved={handleResolveComment}
        isResolving={isResolving}
        comments={selectedComment}
        user={user}
        currentCommentID={selectedCommentId.length ? selectedCommentId[0] : undefined}
        detailsOnly
      ></CommentsDetailsPopup>
      <FiltersPopup open={showFilters} filters={filterComponents}></FiltersPopup>
      {!showSearch && (
        <MobileView>
          <Box
            display="flex"
            sx={{
              position: "fixed",
              left: 0,
              bottom: 8,
              p: 1,
              gap: 1,
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Button
              variant="outlined"
              startIcon={<Search />}
              sx={{
                width: "70vw",
                backgroundColor: "white",
                borderRadius: 10,
                color: "#D0D5DE",
                borderColor: "#D0D5DE",
              }}
              onClick={() => {
                setShowSearch(true);
              }}
            >
              Search Comment
            </Button>
            <Button
              component="label"
              role={undefined}
              variant="contained"
              color="secondary"
              startIcon={<Add></Add>}
              sx={
                isMobile
                  ? {
                      maxWidth: 35,
                      minWidth: 35,
                      height: 35,
                      backgroundColor: "white",
                      borderRadius: 17.5,
                      p: 0,
                      ".MuiButton-startIcon": { margin: 0 },
                    }
                  : {
                      pr: 1.5,
                      pl: 1,
                      py: 0,
                      lineHeight: "35px",
                      borderRadius: "20px",
                    }
              }
              onClick={() => {
                setAddCommentsPopup(true);
              }}
            ></Button>
          </Box>
        </MobileView>
      )}
    </>
  );
};

export default ObservationPage;
